var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2380_591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00175476 2.625C0.00175476 2.16087 0.186129 1.71575 0.514318 1.38756C0.842507 1.05937 1.28763 0.875 1.75175 0.875H12.2518C12.7159 0.875 13.161 1.05937 13.4892 1.38756C13.8174 1.71575 14.0018 2.16087 14.0018 2.625V11.375C14.0018 11.8391 13.8174 12.2842 13.4892 12.6124C13.161 12.9406 12.7159 13.125 12.2518 13.125H1.75175C1.28763 13.125 0.842507 12.9406 0.514318 12.6124C0.186129 12.2842 0.00175476 11.8391 0.00175476 11.375V2.625ZM0.876755 10.5V11.375C0.876755 11.6071 0.968942 11.8296 1.13304 11.9937C1.29713 12.1578 1.51969 12.25 1.75175 12.25H12.2518C12.4838 12.25 12.7064 12.1578 12.8705 11.9937C13.0346 11.8296 13.1268 11.6071 13.1268 11.375V8.3125L9.82188 6.60887C9.73982 6.56777 9.64692 6.55351 9.55632 6.56812C9.46571 6.58272 9.38199 6.62545 9.317 6.69025L6.07076 9.9365L3.74325 8.386C3.65922 8.33005 3.55842 8.30489 3.45795 8.31478C3.35748 8.32466 3.26352 8.36899 3.192 8.44025L0.876755 10.5ZM5.25175 4.8125C5.25175 4.4644 5.11347 4.13056 4.86733 3.88442C4.62119 3.63828 4.28735 3.5 3.93925 3.5C3.59116 3.5 3.25732 3.63828 3.01118 3.88442C2.76504 4.13056 2.62675 4.4644 2.62675 4.8125C2.62675 5.1606 2.76504 5.49444 3.01118 5.74058C3.25732 5.98672 3.59116 6.125 3.93925 6.125C4.28735 6.125 4.62119 5.98672 4.86733 5.74058C5.11347 5.49444 5.25175 5.1606 5.25175 4.8125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2380_591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.282c49b8de0d0083166e2df4cf37b25e.svg";
export { ForwardRef as ReactComponent };